import React from 'react';
import BtnStandard from '../components/BtnStandard';
import cover from "../assets/images/cover.png"

const Home = () => {
    return (
        <>
            <section className='section-main df aic jcc '>
                <img className='cover-full' alt="couverture" src={cover}></img>
                <div className='pr df aic wrapper jcc'>
                    <div className='df fdc aic jcc'>
                        <p className='cw fr fs45 tac'>Payer<br></br> en toute<br></br> sécurité</p>
                        <div className='df aic mt3'>
                            <BtnStandard label={"Nos produits"} />
                            <p></p>
                        </div>
                    </div>
                   
                </div>

            </section>
        </>
    );
};

export default Home;